import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';
import { initializeApp } from 'firebase/app';
import { getAnalytics } from 'firebase/analytics';


// Initialize Firebase
const firebaseApp = initializeApp(environment.firebase);

// Initialize Analytics (non-blocking — won't break the app if it fails)
try {
  getAnalytics(firebaseApp);
} catch (e) {
  console.warn('Firebase Analytics initialization skipped:', e);
}

if (environment.production) {
  enableProdMode();
}

platformBrowserDynamic().bootstrapModule(AppModule)
  .catch(err => console.error(err));
